export default {
  readMoreIntro: {
    id: 'hub_buying_guide_read_more_intro',
    defaultMessage: 'Read more',
  },
} as const
